import apiClient from './api';

export interface Category {
  id: string;
  name: string;
  schema: any;
  uiConfig: any;
}

export interface Item {
  id: string;
  categoryId: string;
  data: {
    bezeichnung: string;
    id: string;
    storageLocation?: string;
    standort?: string;
    quantity?: number;
    instances?: Array<{
      id: number;
      identifier: string;
      type: string;
      storageLocation?: string;
    }>;
    [key: string]: any;
  };
  metadata: any;
  category?: Category;
  compartments?: Compartment[];
}

export interface Compartment {
  id: string;
  itemId: string;
  name: string;
  position: number;
  contents: {
    items: Array<{ 
      itemId?: string; 
      name: string; 
      qty: number | string;
      instances?: Array<{
        expiryDate: string | null;
        batchNumber?: string;
        serialNumber?: string;
        condition?: string;
        notes?: string;
      }>;
      nextExpiry?: string | null;
    }>;
    modulePacks?: Array<{
      name: string;
      items: Array<{ 
        itemId?: string; 
        name: string; 
        qty: number | string;
        instances?: Array<{
          expiryDate: string | null;
          batchNumber?: string;
          serialNumber?: string;
          condition?: string;
          notes?: string;
        }>;
        nextExpiry?: string | null;
      }>;
    }>;
  };
}

export const inventoryService = {
  getCategories: async (): Promise<Category[]> => {
    const response = await apiClient.get('/inventory/categories');
    return response.data;
  },

  getItems: async (categoryId?: string, storageLocation?: string): Promise<Item[]> => {
    const params: Record<string, string> = {};
    if (categoryId) {
      params.categoryId = categoryId;
    }
    if (storageLocation) {
      params.storageLocation = storageLocation;
    }
    const response = await apiClient.get('/inventory/items', { params });
    return response.data;
  },

  getItem: async (id: string): Promise<Item> => {
    const response = await apiClient.get(`/inventory/items/${id}`);
    return response.data;
  },

  updateItem: async (id: string, data: Partial<Item>) => {
    const response = await apiClient.put(`/inventory/items/${id}`, data);
    return response.data;
  },

  createItem: async (payload: { categoryId: string; name: string; quantity?: number; storageLocation?: string }) => {
    const response = await apiClient.post('/inventory/items', payload);
    return response.data;
  },

  updateCompartment: async (id: string, contents: any) => {
    const response = await apiClient.put(`/inventory/compartments/${id}`, { contents });
    return response.data;
  },

  createCompartment: async (itemId: string, name: string) => {
    const response = await apiClient.post(`/inventory/items/${itemId}/compartments`, { name });
    return response.data;
  },

  renameCompartment: async (id: string, name: string) => {
    const response = await apiClient.put(`/inventory/compartments/${id}/name`, { name });
    return response.data;
  },

  deleteCompartment: async (id: string) => {
    const response = await apiClient.delete(`/inventory/compartments/${id}`);
    return response.data;
  },

  deleteItem: async (id: string) => {
    const response = await apiClient.delete(`/inventory/items/${id}`);
    return response.data;
  },

  search: async (query: string) => {
    const response = await apiClient.get('/inventory/search', { params: { q: query } });
    return response.data;
  },
};
